// removed by extract-text-webpack-plugin
module.exports = {"stock-details":"finance_stock-details_x","stock-details-table":"finance_stock-details_stock-details-table","caps":"finance_stock-details_caps","no-transform":"finance_stock-details_no-transform","positive":"finance_stock-details_positive","negative":"finance_stock-details_negative"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/stock-details/style.less
// module id = 1062
// module chunks = 0